var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6242_55082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 1.83301C5.93992 1.83301 1.83325 5.93967 1.83325 10.9997C1.83325 16.0597 5.93992 20.1663 10.9999 20.1663C16.0599 20.1663 20.1666 16.0597 20.1666 10.9997C20.1666 5.93967 16.0599 1.83301 10.9999 1.83301Z",
    fill: "url(#paint0_linear_6242_55082)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.09253,
    y: 14.1953,
    width: 11,
    height: 1.83333,
    rx: 0.916667,
    transform: "rotate(-45 8.09253 14.1953)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 11.6025,
    width: 1.83333,
    height: 5.5,
    rx: 0.916667,
    transform: "rotate(-45 5.5 11.6025)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6242_55082",
    x1: 20.1666,
    y1: 1.83301,
    x2: 1.83325,
    y2: 20.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8FB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6242_55082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioTickIcon);
export default __webpack_public_path__ + "static/media/radio-tick-icon.868309294fd44f77a2ed74c7502f332d.svg";
export { ForwardRef as ReactComponent };